import React from 'react';
import { chartFrameClassName } from './chartToolbarPresentation';

interface ChartFrameProps {
  toolbar: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

const ChartFrame: React.FC<ChartFrameProps> = ({ toolbar, children, className = '' }) => (
  <div className={`${chartFrameClassName} ${className}`}>
    {toolbar}
    {children}
  </div>
);

export default ChartFrame;
